
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Vier von fünf Patienten hilft es, reinen Sauerstoff einzuatmen. Ausserdem werden Triptane als Spritze oder Nasenspray eingesetzt. Auch das lokale Betäubungsmittel Lidocain kann – in der Nase angewendet – helfen. Möglicherweise reduzieren die gegen Migräne entwickelten Galcanezumab-Spritzen die Zahl der Cluster-Anfälle, wie eine Studie zeigte. Dieses neue Medikament ist dafür aber bis jetzt nicht zugelassen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;